import { CONTENT_TYPE_PRODUCT_FEE } from '../../../../../prebuilt/content-types/product-fee-type/constant';
import AbstractStructuredContentController from '../../../abstract/structured-content/controller';

class Controller extends AbstractStructuredContentController {
    constructor(widget) {
        super(widget, CONTENT_TYPE_PRODUCT_FEE);
    }
}

export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-product-fee/widget/scripts/controller.js